import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { TimeoutError, catchError, throwError, timeout } from 'rxjs';

const REQUEST_TIMEOUT_MS = 30_000;

/** Encerra request pendurado para o loader não bloquear a tela em rede móvel. */
export const requestTimeoutInterceptor: HttpInterceptorFn = (request, next) =>
   next(request).pipe(
      timeout(REQUEST_TIMEOUT_MS),
      catchError((error: unknown) => {
         if (error instanceof TimeoutError) {
            return throwError(
               () =>
                  new HttpErrorResponse({
                     status: 0,
                     statusText: 'Timeout',
                     url: request.url,
                     error: { Message: 'ServiceConnectionFailed' },
                  }),
            );
         }

         return throwError(() => error);
      }),
   );
